export class TierRule
{
	id: number;
	active_from: string;
	from: number;
	till: number;
	price_per_thousand: number;
}



// WEBPACK FOOTER //
// ./src/app/models/tier-rule.ts